import { useState, useEffect } from 'react';
import { usageTrackingService } from '@/services/usageTracking';

export const useUsageTracking = () => {
  const [currentUsage, setCurrentUsage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(2);
  const [loading, setLoading] = useState(true);

  const fetchUsage = async () => {
    try {
      setLoading(true);
      const usage = await usageTrackingService.getCurrentUsage();
      const userLimit = await usageTrackingService.getCurrentLimit();
      setCurrentUsage(usage);
      setLimit(userLimit === -1 ? Infinity : userLimit);
    } catch (error) {
      console.error('Error fetching usage:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsage();
  }, []);

  const checkCanRunAnalysis = async () => {
    const result = await usageTrackingService.checkCanRunAnalysis();
    setCurrentUsage(result.currentUsage);
    setLimit(result.limit === Infinity ? Infinity : result.limit);
    return result;
  };

  return {
    currentUsage,
    limit,
    remaining: limit === Infinity ? Infinity : limit - currentUsage,
    loading,
    fetchUsage,
    checkCanRunAnalysis
  };
};